// Added by Sejune Oh on 2019-03-29
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { action, makeObservable, observable } from 'mobx'

import Rootstore from '../index'
import DataStorageStoreBase from '../base/DataStorageStoreBase'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Interface
export interface DSDataServiceElementProps {
  id?: string
  fk_series_id?: string
  username?: string
  user_email?: string
  user_display_name?: string
  page_id?: string
  file_name?: string
  description?: string
  tags?: Array<string>
  thumbnail_base64?: string
  plan?: PlanProps
  created_at?: string
  updated_at?: string
  deleted_at?: string
}

export interface PlanProps {
  plan_id?: string
  approved?: true
  approver_name?: string
  approver_email?: string
  approver_displayname?: string
  approved_at?: string
  surgical_information?: SurgicalInformationProps
}

export interface SurgicalInformationProps {
  procedure_type?: string
  surgery_hospital?: string
  surgeon_name?: string
  surgery_at?: string
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export default class DataStorageDataServiceStore extends DataStorageStoreBase<DSDataServiceElementProps> {
  totalCount: number = 0
  elements: Array<DSDataServiceElementProps> = []
  root?: Rootstore
  _subUrl: string = 'jobsaves'

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  constructor(root: Rootstore) {
    super({ storeName: 'DS_StudyStore', apiSubUrl: 'dcm/series', _root: root })
    this.root = root
    makeObservable(this, {
      totalCount: observable,
      elements: observable,
      _setTotalCount: action,
      setElements: action,
    })
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  getElement = async (id: string, foreignSeriesKeyId: string) => {
    return await super.get(id, foreignSeriesKeyId, this._subUrl)
  }

  getElements = async (path: string, foreignSeriesKeyId: string) => {
    const rtnData = await super.getAll(path, foreignSeriesKeyId, this._subUrl)
    await this._setTotalCount(parseInt(rtnData.total_count as string))
    return rtnData.items as Array<DSDataServiceElementProps>
  }

  addElement = async (element: DSDataServiceElementProps, foreignSeriesKeyId: string) => {
    const newElement = await super.add(element, foreignSeriesKeyId, this._subUrl)
    return newElement.id
  }

  removeElement = async (id: string, foreignSeriesKeyId: string) => {
    return await super.remove(id, foreignSeriesKeyId, this._subUrl)
  }

  updateElement = async (id: string, element: DSDataServiceElementProps, foreignSeriesKeyId: string) => {
    const updatedElement = await super.update(id, element, foreignSeriesKeyId, this._subUrl)
    return updatedElement.id
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  _setTotalCount = (count: number) => {
    this.totalCount = count
  }

  setElements = (elements: Array<DSDataServiceElementProps>) => {
    this.elements = elements
  }
}
